import { useIntl } from "react-intl";

import Card from "components/v2/Card/Card";
import testIds from "constants/testIds";
import Textarea from "components/v2/Textarea/Textarea";

export default function ReviewComment() {
  const intl = useIntl();

  return (
    <Card borderRadius="xl" shadow="xs" data-testid={testIds.REQUEST_FORM_REVIEW_COMMENTS}>
      <Card.Header
        title={intl.formatMessage({ id: "request-form.review.comment.title", defaultMessage: "Comments" })}
        showBorder
      />
      <Card.Body>
        <div className="rfv2-review__section-content">
          <Textarea
            name="shipment.comments"
            label={intl.formatMessage({
              id: "request-form.review.comment.label",
              defaultMessage: "Additional comments",
            })}
            placeholder={intl.formatMessage({
              id: "request-form.review.comment.placeholder",
              defaultMessage: "Type in your comment",
            })}
          />
        </div>
      </Card.Body>
    </Card>
  );
}
